import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import BookingEditModal from "./BookingEditModal";
import { axiosInstanceWithToken } from "../helpers/axios";
import { getBookingStatusAndStyles } from "@/helpers";
import Swal from "sweetalert2";
import { fDateMoment } from "@/utils/formatDate";
function BokkingR() {
  const [data, setData] = useState([]);
  const [isOpen2, setIsOpen2] = useState(false);
  const [loading, setLoading] = useState(true);
  const path = useNavigate();

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "guest.display_name",
        header: "Guest",
        size: 150,
      },
      {
        accessorKey: "created_at",
        header: "Date Created",
        size: 150,
        Cell: ({ row }) => {
          const date = row.original.created_at;
          return date ? fDateMoment(date) : "N/A";
        },
      },
      {
        accessorKey: "address",
        header: "Address",
        size: 150,
      },
      {
        accessorKey: "arrival_date",
        header: "Check in",
        size: 150,
        Cell: ({ row }) => {
          const date = row.original.arrival_date;
          return date ? fDateMoment(date) : "N/A";
        },
      },
      {
        accessorKey: "departure_date",
        header: "Check out",
        size: 150,
        Cell: ({ row }) => {
          const date = row.original.departure_date;
          return date ? fDateMoment(date) : "N/A";
        },
      },
      {
        accessorKey: "meta_data.listing_rates.nightly",
        header: "Rent $",
        size: 150,
      },
      {
        accessorKey: "no_of_guests",
        header: "Additional Guests $",
        size: 150,
        Cell: ({ row }) => row.original?.meta_data?.additionalGuestsPrice || 0,
      },
      {
        accessorKey: "no_of_pets",
        header: "Pet Fee",
        size: 150,
        Cell: ({ row }) => row.original?.meta_data?.petsPrice || 0,
      },
      {
        accessorKey: "meta_data.extraServicesPrice",
        header: "Extra Services $",
        size: 150,
        Cell: ({ row }) => row.original.meta_data?.extraServicesPrice || 0,
      },
      {
        accessorKey: "meta_data.totalCleaningFee",
        header: "Cleaning Fee",
        size: 150,
        Cell: ({ row }) => row.original.meta_data?.totalCleaningFee || 0,
      },
      {
        accessorKey: "meta_data.platformFee",
        header: "Platform Fee",
        size: 150,
      },
      {
        accessorKey: "meta_data.totalAmount",
        header: "Total before tax",
        size: 150,
        Cell: ({ row }) => row.original.meta_data?.totalAmount || 0,
      },
      {
        accessorKey: "meta_data.taxAmount",
        header: "Taxes",
        size: 150,
      },
      {
        accessorKey: "amount",
        header: "Total",
        size: 150,
        Cell: ({ row }) => row.original.meta_data?.amountAfterTax || 0,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 150,
        Cell: ({ row }) => {
          const status = row.getValue("status");

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                className={`shadow-md rounded ${
                  getBookingStatusAndStyles(status).buttonColor
                } ${getBookingStatusAndStyles(status).textColor}`}
                style={{ padding: "7px 10px" }}
              >
                {getBookingStatusAndStyles(status).label}
              </button>
            </div>
          );
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        size: 150,
        Cell: ({ row }) => {
          const carReview =
            row.getValue("status").toUpperCase() === "COMPLETED";

          const handleAction = (action) => {
            if (action === "View") {
              path("/booking_view", {
                state: { row: row.original, isHost: true },
              });
            } else if (action === "Review") {
              handleOpenModal({
                booking_id: row.original.id,
                listing_id: row?.original?.listing?.id,
              });
            }
          };

          return (
            <div style={{ position: "relative" }}>
              <select
                style={{ fontWeight: "600" }}
                className="shadow-md bg-white cursor-pointer p-[10px] rounded border-soft"
                onChange={(e) => handleAction(e.target.value)}
              >
                <option value="">Select Action</option>
                {carReview && <option value="Review">Review</option>}
                <option value="View">View</option>
              </select>
            </div>
          );
        },
      },
    ],
    [path]
  );

  console.log(data);

  const tableMemoized = useMemo(() => {
    return (
      <div className="mt-5">
        <MaterialReactTable
          key={data.length} // Ensures re-render when data updates
          columns={columns}
          data={data}
          muiPaginationProps={{
            rowsPerPageOptions: [
              { value: 10, label: "10" },
              { value: 25, label: "25" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
              { value: data.length, label: "All" },
            ],
            showFirstButton: false,
            showLastButton: false,
          }}
          positionActionsColumn="last"
        />
      </div>
    );
  }, [data, columns]);

  useEffect(() => {
    Swal.fire({
      icon: "info",
      text: "Please scroll right and left to view more columns.",
      showConfirmButton: true,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstanceWithToken.get(
          "/booking?per_page=10"
        );
        if (response?.data?.status) {
          setData(
            response?.data?.data?.bookings.map((booking) => ({
              ...booking,
              meta_data:
                typeof booking?.meta_data === "string"
                  ? JSON.parse(booking?.meta_data)
                  : booking?.meta_data,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [selectedId, setSelectedId] = useState(null);

  const handleOpenModal = (id) => {
    setSelectedId(id);
    setIsOpen2(true);
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <>
      {isOpen2 && (
        <BookingEditModal
          selectedId={selectedId}
          setIsOpen2={setIsOpen2}
          isOpen2={isOpen2}
          type={"HOST_TO_GUEST"}
        />
      )}

      <div className="px-4 col-md-12">
        <div className="dashboard-title">
          <h3>My Bookings</h3>
        </div>

        {tableMemoized}
      </div>
    </>
  );
}

export default BokkingR;
